import packageJson from "@/package.json";
import { Link } from "@/i18n/navigation";
import Image from "next/image";
import { useTranslations } from "next-intl";

export default function Footer() {
  const t = useTranslations('footer');
  const version = packageJson.version;
  const buildDate = packageJson.buildDate;

  return (
    <footer className="w-full border-t border-black/20 bg-black text-white py-10">
      <div className="container mx-auto px-4">
        {/* Top brand + newsletter */}
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-6 pb-8 border-b border-white/10">
          <div className="flex items-center">
            <Image src="/da4ndo.png" alt="Da4ndo" width={40} height={40} className="rounded-full" />
            <span className="text-xl font-semibold mx-3">&</span>
            <Image src="/BME.svg" alt="BME" width={110} height={28} className="invert brightness-0" />
          </div>
          {/* Newsletter removed as requested */}
        </div>

        {/* Links */}
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-8 py-8">
          <div>
            <h3 className="text-sm font-semibold text-white mb-3">{t('product')}</h3>
            <ul className="space-y-2 text-sm text-white/90">
              <li><Link href="/docs" className="hover:text-white transition">{t('docs')}</Link></li>
              <li><Link href="/docs/metrics" className="hover:text-white transition">{t('metrics')}</Link></li>
              <li><Link href="/docs/author-search" className="hover:text-white transition">{t('authorSearch')}</Link></li>
            </ul>
          </div>
          <div>
            <h3 className="text-sm font-semibold text-white mb-3">{t('company')}</h3>
            <ul className="space-y-2 text-sm text-white/90">
              <li><Link href="/contact" className="hover:text-white transition">{t('contact')}</Link></li>
              <li><a href="https://www.bme.hu/" className="hover:text-white transition">{t('bme')}</a></li>
              <li><a href="https://da4ndo.com" className="hover:text-white transition">{t('da4ndo')}</a></li>
            </ul>
          </div>
          <div>
            <h3 className="text-sm font-semibold text-white mb-3">{t('legal')}</h3>
            <ul className="space-y-2 text-sm text-white/90">
              <li><Link href="/privacy-policy" className="hover:text-white transition">{t('privacy')}</Link></li>
              <li><Link href="/terms-of-service" className="hover:text-white transition">{t('terms')}</Link></li>
            </ul>
          </div>
          <div>
            <h3 className="text-sm font-semibold text-white mb-3">{t('status')}</h3>
            <ul className="space-y-2.5 text-sm">
              <li className="flex items-center gap-2">
                <span className="inline-block w-2 h-2 rounded-full bg-green-400 animate-pulse" />
                <span className="text-white/90">{t('operational')}</span>
              </li>
              <li className="flex flex-col gap-0.5">
                <span className="text-white/70 text-xs">{t('version')}</span>
                <Link href="/" className="text-white/90 hover:text-white transition font-medium">
                  v{version}
                </Link>
              </li>
              <li className="flex flex-col gap-0.5">
                <span className="text-white/70 text-xs">{t('lastUpdated')}</span>
                <span className="text-white/90">
                  {new Date(buildDate).toLocaleDateString(undefined, { 
                    year: 'numeric', 
                    month: 'short', 
                    day: 'numeric' 
                  })}
                </span>
              </li>
            </ul>
          </div>
          <div>
            <h3 className="text-sm font-semibold text-white mb-3">{t('follow')}</h3>
            <ul className="space-y-2 text-sm text-white/90">
              <li>
                <a 
                  href="https://www.facebook.com/muegyetem.official" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="hover:text-white transition"
                >
                  Facebook
                </a>
              </li>
              <li>
                <a 
                  href="https://www.instagram.com/unibme.official/" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="hover:text-white transition"
                >
                  Instagram
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="pt-6 border-t border-white/10 text-center text-xs text-white/80">
          <p>
            © {new Date().getFullYear()} <a href="https://kozlekedes.bme.hu" className="hover:text-white transition">BME Közlekedésmérnöki és Járműmérnöki Kar</a> & <a href="https://da4ndo.com" className="hover:text-white transition">Da4ndo</a>
          </p>
        </div>
      </div>
    </footer>
  );
}
